import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ZoomTable from '../../commons/zoomTable/zoomTable';
import { data } from './excel-data';
import {
  getAllHigherFloorVas,
  updatePageNumber,
  changeTaskStatus,
  updateFilter,
  bulkUploadAppointment
} from './addressFloorTaggingRedux/addressFloorTaggingActionCreator';

import { setPageName } from '../../../services/pageService/pageActionCreator';
import { higherFloorVasStatus } from '../../helper/AddressFloorTaggingHelper';
import BulkUploadModal from '../ceTaskboard/bulkUploadModal';
import styles from './addressFloorTagging.scss';
import ClientSearch from '../../commons/clientSearch';
import { jsonToCSVConvertor } from '../../../services/helpers';

const pageObj = {
  pageName: 'ADDRESS FLOOR TAGGING',
  betaPage: false
};

class AddressFloorTagging extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRowData: {},
      isBulkUploadModalVisible: false,
      isPoDetailsModalVisible: false
    };
    this.componentKey = 'ADDRESS_FLOOR_TAGGING';
    this.tableActionFunctions = {
      approveTask: rowData =>
        this.changeTaskStatus(rowData, higherFloorVasStatus.APPROVE),
      rejectTask: rowData =>
        this.changeTaskStatus(rowData, higherFloorVasStatus.REJECT),
      getPoDetailsAndOpenModal: rowData =>
        this.getPoDetailsAndOpenModal(rowData)
    };
    this.closeBulkUploadModal = this.closeBulkUploadModal.bind(this);
    this.closePoDetailsModal = this.closePoDetailsModal.bind(this);
    this.onSearchKeyPress = this.onSearchKeyPress.bind(this);
    this.statusListNameValStrings = { nameKey: 'key', valKey: 'val' };
  }
  componentWillMount() {
    this.props.setPageName(pageObj);
  }

  componentDidMount() {
    this.props.getAllHigherFloorVas();
  }

  onSearchKeyPress(event) {
    if (event.key === 'Enter') {
      this.props.getAllHigherFloorVas();
    }
  }

  getPoDetailsAndOpenModal(consignmentId) {
    this.setState({ isPoDetailsModalVisible: true }, () => {
      this.props.getPoDetailsByConsignmentId(consignmentId);
    });
  }

  openBulkUploadModal() {
    this.setState({
      isBulkUploadModalVisible: true
    });
  }

  changeTaskStatus(rowData, status) {
    this.props.changeTaskStatus(rowData, status);
  }

  closeBulkUploadModal() {
    this.setState({ isBulkUploadModalVisible: false });
  }

  closePoDetailsModal() {
    this.setState({ isPoDetailsModalVisible: false });
  }

  handleFilterChange(key, val) {
    this.props.updateFilter(key, val);
    this.props.getAllHigherFloorVas();
  }

  renderTable() {
    return (
      <div>
        <ZoomTable
          configKey={this.componentKey}
          tableData={
            (this.props.addressFloorTaggingState.taskboardData &&
              this.props.addressFloorTaggingState.taskboardData) ||
            []
          }
          tableDataLength={
            (this.props.addressFloorTaggingState.taskboardData &&
              this.props.addressFloorTaggingState.taskboardData.length) ||
            0
          }
          loading={this.props.addressFloorTaggingState.isLoading}
          paginationProps={{
            showPagination: true,
            page: this.props.addressFloorTaggingState.pageNumber,
            pageSize:
              this.props.addressFloorTaggingState.taskboardData &&
              this.props.addressFloorTaggingState.taskboardData.length
                ? this.props.addressFloorTaggingState.length
                : 0,
            serverSidePagination: true,
            pages: Math.ceil(
              this.props.addressFloorTaggingState.totalElements /
                this.props.addressFloorTaggingState.pageSize
            ),
            onFetchData: tableState => {
              if (
                this.props.addressFloorTaggingState.pageNumber !==
                tableState.page
              ) {
                this.props.updatePageNumber(tableState.page);
                this.props.getAllHigherFloorVas();
              }
            }
          }}
          actionFunctions={this.tableActionFunctions}
        />
      </div>
    );
  }

  renderClientFilter() {
    return (
      <ClientSearch
        onSelect={(_, obj) => {
          this.handleFilterChange('client', obj);
        }}
        showAllOption
        disableNone
      />
    );
  }

  renderFilterPanel() {
    return (
      <div className="zt-filter-panel-parent l-row a-center">
        <div className="zt-filter-panel-left l-row flex-70">
          <div className="zt-filter-label l-row a-center">Filter By:</div>
          {this.renderClientFilter()}
        </div>
        <div className="flex-40 l-row j-end a-center a-end">
          <div
            className={`${styles.secondaryBtnWrapper} ${styles.big} l-row j-center a-center`}
            onClick={() => this.openBulkUploadModal()}
          >
            Bulk Upload Floor
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.renderFilterPanel()}

        {this.renderTable()}
        <BulkUploadModal
          showModal={this.state.isBulkUploadModalVisible}
          closeModal={this.closeBulkUploadModal}
          bulkUploadAppointment={this.props.bulkUploadAppointment}
          downloadExcel={() => {
            jsonToCSVConvertor(data.rows, 'sample.csv', data.headers);
          }}
          source={'addressFloorTagging'}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  addressFloorTaggingState: state.addressFloorTaggingState
});

const mapDispatchToProps = dispatch => ({
  setPageName: bindActionCreators(setPageName, dispatch),
  getAllHigherFloorVas: bindActionCreators(getAllHigherFloorVas, dispatch),
  updatePageNumber: bindActionCreators(updatePageNumber, dispatch),
  changeTaskStatus: bindActionCreators(changeTaskStatus, dispatch),
  updateFilter: bindActionCreators(updateFilter, dispatch),
  bulkUploadAppointment: bindActionCreators(bulkUploadAppointment, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddressFloorTagging);
